export const messageLength = value => Array.from(value || '').length;

export function renderClientName(template, name) {
    const firstName = (name || '').trim().split(/\s+/)[0];
    if (firstName) return template.split('{client_name}').join(firstName).trim();
    return template.replace(/\*\{client_name\}\*|_\{client_name\}_|\{client_name\}/g, '')
        .replace(/[ \t]+([,!.?;:])/g, '$1').replace(/[ \t]{2,}/g, ' ')
        .replace(/[,;:][ \t]*([.!?])/g, '$1').trim();
}

export const visibleOptions = configuration => configuration.options.filter(option => option.enabled);
export const optionTitle = option => `${option.emoji || ''} ${option.title}`.trim();

export function buildAdvancedPreview(configuration, name, provider) {
    const body = renderClientName(configuration.body_text, name) || 'Como podemos ajudar você hoje?';
    const options = visibleOptions(configuration);
    const text = [body, ...options.map((option, index) =>
        `${index + 1}\uFE0F\u20E3 ${optionTitle(option)}${option.description ? `\n${option.description}` : ''}`)].filter(Boolean).join('\n\n');
    if (name && messageLength(text) > 4096) return buildAdvancedPreview(configuration, '', provider);
    const mode = provider === 'cloud_api' && options.length && messageLength(body) <= 1024 ? configuration.display_mode : 'text';
    return { body, text, options, mode };
}

export function validateAdvancedMessage(configuration) {
    if (!configuration.body_text.trim()) return 'Informe o texto de apresentação.';
    if (messageLength(configuration.body_text) > 2000) return 'A apresentação deve ter até 2.000 caracteres.';
    if (!configuration.list_button_text.trim() || messageLength(configuration.list_button_text) > 20) return 'O botão da lista deve ter entre 1 e 20 caracteres.';
    const options = visibleOptions(configuration);
    for (const option of configuration.options) {
        if (!option.title.trim() || messageLength(option.title) > 100) return 'Cada título deve ter entre 1 e 100 caracteres.';
        if (messageLength(option.description) > 500) return 'Cada descrição deve ter até 500 caracteres.';
        const emoji = (option.emoji || '').trim();
        if (emoji && (!/[\p{Extended_Pictographic}\p{Regional_Indicator}\u20E3]/u.test(emoji)
            || (typeof Intl.Segmenter === 'function' && Array.from(new Intl.Segmenter().segment(emoji)).length !== 1))) return 'Informe somente um emoji por opção.';
    }
    if (messageLength(buildAdvancedPreview(configuration, '', 'whatsapp_web_js').text) > 4096) return 'A mensagem completa deve ter até 4.096 caracteres.';
    if (configuration.display_mode === 'text') return '';
    if (messageLength(configuration.body_text) > 1024) return 'A apresentação interativa deve ter até 1.024 caracteres.';
    if (!options.length) return 'Ative pelo menos uma opção para o formato interativo.';
    if (configuration.display_mode === 'buttons' && options.length > 3) return 'Use uma lista para apresentar quatro opções ou desative uma delas.';
    const titleLimit = configuration.display_mode === 'buttons' ? 20 : 24;
    if (options.some(option => messageLength(optionTitle(option)) > titleLimit)) return `Os títulos com emoji devem ter até ${titleLimit} caracteres neste formato.`;
    if (configuration.display_mode === 'list' && options.some(option => messageLength(option.description) > 72)) return 'As descrições da lista devem ter até 72 caracteres.';
    return '';
}
